import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { inFavoriteSelector } from '../../store/favorite/selectors';

export const ServiceHeaderStructuredSelector = createStructuredSelector({
  inFavorite: inFavoriteSelector
});

export const ServiceHeaderPropTypes = {
  inFavorite: PropTypes.bool.isRequired
};
